import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../../Components/Login/Login";

export default function LoginPage({ isAuthenticated }) {
  const [isAuth, setIsAuth] = isAuthenticated;

  let navigate = useNavigate();

  useEffect(() => {
    isAuth
      ? navigate("/Dashboard", { replace: true })
      : navigate("/Login", { replace: true });

    console.log("Is Authorized?");
    console.log(isAuth);
  }, [isAuth, navigate]);

  return <Login isAuthenticated={[isAuth, setIsAuth]} />;
}
